import { Slot } from "../ProductCardSlot";
import styles from "../Standard/Standard.module.scss";
import stylesPLP2846 from "./StandardTitleSlot-PLP-2846.module.scss";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";
import { ProductCardLayout } from "@~/types/types.ts";

export const slotNameMap = {
  BANNER: "banner",
  IMAGE: "image",
  ACTIONS: "actions",
  DRAWER: "drawer",
  MAIN: "main",
  TITLE: "title",
  DETAILS: "details",
};

export const StandardTitleSlotPLP2846: ProductCardLayout = (props) => {
  const { product, config } = props;
  return (
    <article
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={styles["card-container"]}
      data-product-card-layout="StandardTitleSlotPLP2846"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      id={product?.aliases?.pimProductId} // Needed for wish list scrolling
      ref={props.eventsRef}
    >
      <div className={styles["image-container"]}>
        <Slot
          slotName={slotNameMap["BANNER"]}
          className={styles["banner-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["IMAGE"]}
          className={styles["image-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["ACTIONS"]}
          className={styles["actions-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["DRAWER"]}
          className={styles["drawer-slot"]}
          {...props}
        />
      </div>
      <Slot
        slotName={slotNameMap["MAIN"]}
        className={styles["main-slot"]}
        {...props}
      />
      <Slot
        slotName={slotNameMap["TITLE"]}
        className={stylesPLP2846["title-slot-horizontal"]}
        bordered={!config["product-card-layout"].props?.hideDetailsBorder}
        {...props}
      />
      <Slot
        slotName={slotNameMap["DETAILS"]}
        className={styles["details-slot"]}
        bordered={!config["product-card-layout"].props?.hideDetailsBorder}
        {...props}
      />
    </article>
  );
};
